import { createState } from '@store/utils/createState';
import { atom } from 'jotai';

import type { Media, MediaEntityType } from './types';
import { MediaType } from './types';

export const initialState = (): Media => ({
  id: '',
  name: '',
  path: '',
  type: MediaType.Avatar,
  mimeType: '',
  createdAt: '',
  updatedAt: '',
  entityId: null,
  entityType: null,
  imgixUrl: null,
  url: {
    url: '',
    expiresIn: 0,
  },
  cloudFrontUrl: {
    url: '',
    expiresIn: 0,
  },
});

export const {
  state: mediaState,
  listState: mediaListState,
  idsState: mediaIdsState,
} = createState({ initialState });

/**
 * Get media IDs by entity
 * @param entityId - The entity ID
 * @param entityType - The entity type (e.g., 'USER', 'ORGANIZATION')
 */
export const mediaIdsByEntityState = (entityId: string, entityType: MediaEntityType) =>
  atom<string[]>((get) => {
    const mediaList = get(mediaListState);

    return mediaList
      .filter((m) => m.entityId === entityId && m.entityType === entityType)
      .map((m) => m.id);
  });

/**
 * Get media items by entity
 * @param entityId - The entity ID
 * @param entityType - The entity type (e.g., 'USER', 'ORGANIZATION')
 */
export const mediaByEntityState = (entityId: string, entityType: MediaEntityType) =>
  atom<Media[]>((get) => {
    const mediaList = get(mediaListState);

    return mediaList.filter((m) => m.entityId === entityId && m.entityType === entityType);
  });

export const mediaSingleByEntityStateAndType = (
  entityId: string,
  entityType: MediaEntityType,
  type: MediaType
) =>
  atom<Media | undefined>((get) => {
    const mediaList = get(mediaListState);

    return mediaList.find(
      (m) => m.entityId === entityId && m.entityType === entityType && m.type === type
    );
  });
